/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Pathfinder API
 * API for all Pathfinder applications.
 * OpenAPI spec version: 1.0.0
 */
import type {
  ResourceFlag,
  ResourceFlagCreateRequest
} from '../types';

import { apiV2 } from '../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * Flags a resource as having wrong or outdated information and emails support. A resource can have only one active flag; it clears when the resource is next saved.
 */
export const resourcesFlagsCreate = (
    id: string,
    resourceFlagCreateRequest: ResourceFlagCreateRequest,
 options?: SecondParameter<typeof apiV2<ResourceFlag>>,) => {
      return apiV2<ResourceFlag>(
      {url: `/resources/${id}/flags/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: resourceFlagCreateRequest
    },
      options);
    }
  export type ResourcesFlagsCreateResult = NonNullable<Awaited<ReturnType<typeof resourcesFlagsCreate>>>
